import React, { Component } from 'react';

// Helper function to convert **text** into <strong> components dynamically
const parseBoldText = (text) => {
  if (typeof text !== 'string') return text;

  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
};

export default class Professional extends Component {
  render() {
    const { resumeData } = this.props;

    // Convert jobs to an array if it's an object or array
    const jobsList = Array.isArray(resumeData?.jobs)
      ? resumeData.jobs
      : Object.values(resumeData?.jobs || {});

    return (
      <div className="row work">
        <div className="three columns header-col">
          <h1><span>Work</span></h1>
        </div>

        <div className="nine columns main-col">
          {/* Work Experience Section */}
          {jobsList.map((job, index) => {
            const descriptions = Array.isArray(job.description)
              ? job.description
              : typeof job.description === 'object' && job.description !== null
                ? Object.values(job.description)
                : [job.description];

            return (
              <div className="row item" key={job.company ? `${job.company}-${index}` : index}>
                <div className="twelve columns">
                  <h3>{job.company}</h3>
                  {job.location && <h5>{job.location}</h5>}
                  <p className="info">
                    {job.position} <span>•</span> <em className="date">{job.duration}</em>
                  </p>

                  {descriptions.length > 0 && (
                    <ul className="project text-justify">
                      {descriptions.map((desc, dIndex) => (
                        <li key={dIndex}>
                          {parseBoldText(desc)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            );
          })}

          {/* Dynamic Technical Skills Section */}
          {resumeData?.skills && (
            <div className="row item">
              <div className="twelve columns">
                <h3>Technical Skills</h3>
                {Object.entries(resumeData.skills).map(([key, skillText]) => (
                  <p className="text-justify" key={key}>
                    {parseBoldText(skillText)}
                  </p>
                ))}
              </div>
            </div>
          )}
        </div> {/* main-col end */}
      </div>
    );
  }
}